import React from 'react';

import { AppProvider } from './app';
import { AuthProvider } from './auth';

export const ContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <AppProvider>
    <AuthProvider>
      {children}
    </AuthProvider>
  </AppProvider>
);
